import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LinkPlus.module.css';

/**
 * LinkPlus: Componente que extiende Link de react-router-dom
 *
 * Modos de apertura disponibles:
 * - adaptativo={true}: desktop abre en nueva ventana, mobile en la misma
 * - nuevaVentana={true}: abre siempre en una nueva ventana
 * - default (sin props): abre siempre en la misma ventana
 *
 * Ventajas:
 * - UX mejorada en mobile (evita lagunas de ventanas)
 * - Sin subrayado ni color azul (hereda estilos del padre)
 * - API idéntica a Link + configuración de apertura
 *
 * Uso:
 *   <LinkPlus to="/clubes?pais=1" adaptativo={true}>
 *     Ver clubes
 *   </LinkPlus>
 *
 * Props:
 *   - adaptativo: boolean
 *   - nuevaVentana: boolean
 *   - to: string - ruta de destino (requerido)
 *   - children: node - contenido del link
 *   - className: string (opcional) - clases CSS
 *   - ...props: otros props se pasan a Link
 */
const LinkPlus = ({
  adaptativo = false,
  nuevaVentana = false,
  to,
  children,
  className = '',
  ...props
}) => {
  // Detectar si está en mobile
  const isMobile = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    // Usar media query para detectar viewport pequeño
    return window.matchMedia('(max-width: 768px)').matches;
  };

  // Prioridad: nuevaVentana > adaptativo > misma ventana por default.
  let abrirNuevaVentana = false;
  if (nuevaVentana) {
    abrirNuevaVentana = true;
  } else if (adaptativo) {
    abrirNuevaVentana = !isMobile();
  }

  const target = abrirNuevaVentana ? '_blank' : undefined;
  const rel = abrirNuevaVentana ? 'noopener noreferrer' : undefined;

  return (
    <Link
      to={to}
      target={target}
      rel={rel}
      className={`${styles.LinkPlus} ${className}`.trim()}
      {...props}
    >
      {children}
    </Link>
  );
};

export default LinkPlus;
